// deps
import React, { memo, useMemo } from "react";
import cx from "classnames";

// internal deps
import { Image, AriaHidden, isEmpty } from "@swiggy-private/core-ui";

// helpers
import { getBoldTitle, getPrefixedTestId } from "@super-ui/helpers/String";

// constants
import { ONE_WIDGET_TEST_IDS } from "@super-ui/test-ids/one-widget";
import { TITLE_BOLD } from "@super-ui/constants/SwiggyOne";

import styles from "../styles/SwiggyOneWidget.v4.scss";
import classNames from "classnames";

export interface HeaderProps {
    title: string;
    showTitleShimmer: boolean;
    logoCtx: {
        logo: string;
    };
    testIdPrefix?: string;
    isOneActiveUser?: boolean;
    isBenefitListPresent?: boolean;
    chipText?: string;
    headerColor?: string;
    showBorder?: boolean;
    autoScaleWidth?: boolean;
}

const Header: React.FC<HeaderProps> = ({
    title,
    showTitleShimmer,
    logoCtx,
    testIdPrefix,
    isOneActiveUser = false,
    isBenefitListPresent = false,
    chipText,
    headerColor,
    showBorder = true,
    autoScaleWidth = false,
}: HeaderProps) => {
    const headerTestId = useMemo(() => getPrefixedTestId(ONE_WIDGET_TEST_IDS.HEADER, testIdPrefix), [testIdPrefix]);
    const boldTitle = useMemo(() => getBoldTitle(title ?? "", TITLE_BOLD.OPEN, TITLE_BOLD.CLOSE), [title]);

    const headerIconStyle = useMemo(() => {
        return classNames({
            [styles.headerIcon]: true,
            [styles.headerIconWithChipText]: !isEmpty(chipText) || autoScaleWidth,
        });
    }, [autoScaleWidth, chipText]);

    return (
        <AriaHidden
            as="div"
            className={cx(styles.headerContainer, {
                [styles.headerContainerShimmer]: showTitleShimmer,
                [styles.headerContainerBorder]: showBorder && isOneActiveUser && isBenefitListPresent,
            })}
        >
            <Image imageId={logoCtx?.logo ?? ""} className={headerIconStyle} lazy={false} />

            <h2
                data-testid={headerTestId}
                className={cx(styles.headerText)}
                style={{ color: headerColor || "" }}
                dangerouslySetInnerHTML={{ __html: boldTitle }}
            ></h2>
        </AriaHidden>
    );
};

export default memo(Header);
